export default __webpack_public_path__ + "static/PANASAS_Incorrect-Use-F-41a8409952c878ed503e696c239b2a0c.jpg";